import {NgModule} from "@angular/core";
import {SalesforceUidDerective} from "./features/salesforce-uid/salesforce-uid.directive";
import {SalesforceUidRoutingModule} from "./salesforce-uid-routing.modul";

@NgModule({
  imports: [SalesforceUidRoutingModule],
  declarations: [SalesforceUidDerective]
})
export class SalesforceUidModule {}
